// extracted by mini-css-extract-plugin
export default {"hero_banner":"HeroBanner_hero_banner__okxuG","name_font":"HeroBanner_name_font__l-aaz"};